export enum ERoles {
    SMALL_COMPANY = "small-company",
    LARGE_COMPANY = "large-company",
}
